import { ReservesMapper } from '../api-v2/mappings'
import ReserveV2 from '../api-v2/reserve'
import { Reserve } from '../api'
import { ApiVersionDelagator } from "./api-delegator"
/**
 * @typedef {import('../api-v2/js-doc').V1ExpediteTransferRequest} V1ExpediteTransferRequest
 * @typedef {import('../api-v2/js-doc').V2MappingOptions} V2MappingOptions
 * @typedef {import('../api-v2/js-doc').V1ReserveResponse} V1ReserveResponse
 */

export class ReserveApiDelegator extends ApiVersionDelagator {
  /**
   * @param {string} clientId - ID of the client
   * @param {string} id - ID of the reserve
   * @returns {Promise<V1ReserveResponse>}
   */
  async delete (clientId, id) {
    return await this.runWriteApiCalls(
      clientId,
      id,
      this.#deleteReserveV1,
      async (v2MappingOptions) => {
        return await this.#deleteReserveV2(v2MappingOptions, clientId, id)
      },
      {
        operationName: 'delete-reserve',
      }
    )
  }

  /**
   * @param {string} id - ID of the reserve
   * @returns {Promise<V1ReserveResponse>}
   */
  async #deleteReserveV1 (id) {
    const result = await Reserve.delete(id)
    return result?.data
  }

  /**
   * @param {V2MappingOptions} v2MappingOptions - V2 mapping options
   * @param {string} clientId - ID of the client
   * @param {string} id - ID of the reserve
   * @returns {Promise<V1ReserveResponse>}
   */
  async #deleteReserveV2 (v2MappingOptions, clientId, id) {
    const result = await new ReserveV2(clientId).delete(id, { __ingestThrough: v2MappingOptions.ingestThrough })
    return ReservesMapper.v2ReserveToV1(result)
  }
}
